import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircle as faCircleSolid } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a circle icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/circle?f=classic&s=solid
 */
export const CircleIcon: React.FC<
  CustomIconProps & { variant?: 'solid' | 'regular' }
> = (props) => {
  return (
    <Icon
      icon={props.variant === 'regular' ? faCircle : faCircleSolid}
      {...props}
    />
  );
};
